import {
  ServicioSap,
  ServicioSapDireccion,
  ServicioSapFiltro,
  ServicioSapRequest,
  ServicioSapSearchResult
} from '../../model/servicio-sap/servicio-sap';

/**
 * Puerto Abstracto: ServicioSapRepository
 *
 * Contrato del maestro Administración › Maestro › Servicios SAP (HU1287272).
 *
 * Legacy Reference:
 * - AdminServiciosSapActivity (listado, crear, modificar, eliminar)
 * - ComunesHandler.buscarServiciosSap / AdminServiciosSapHandler
 * - Tabla TPSC_SERVICIOS_SAP
 */
export abstract class ServicioSapRepository {
  /**
   * Busca servicios SAP vigentes (sin fecha de baja) con paginación por cursor.
   * `size` es obligatorio y está acotado a 1..100.
   */
  abstract buscar(
    filtro: ServicioSapFiltro,
    size: number,
    cursor?: string | null,
    direction?: ServicioSapDireccion
  ): Promise<ServicioSapSearchResult>;

  /** Crea un servicio SAP (o lo reactiva si el código estaba dado de baja). */
  abstract crear(request: ServicioSapRequest): Promise<ServicioSap>;

  /** Modifica solo la descripción; el código no es editable. */
  abstract actualizar(
    cdservicio: string,
    dsservicio: string
  ): Promise<ServicioSap>;

  /** Da de baja (baja lógica) el servicio SAP. */
  abstract eliminar(cdservicio: string): Promise<void>;
}
